/**
 * Context window composition variants used for benchmark experiments.
 */

const BASELINE = Object.freeze({
  includeTemporalHistory: false,
  includeExpectedButMissing: false,
  includeCalculatorResults: false,
  cantMissGrounding: 'minimal',
  clinicalViews: false,
  patientContextProfile: false,
  prevalenceCalibration: false,
});

const FULL = Object.freeze({
  includeTemporalHistory: true,
  includeExpectedButMissing: true,
  includeCalculatorResults: true,
  cantMissGrounding: 'full',
  clinicalViews: true,
  patientContextProfile: true,
  prevalenceCalibration: true,
});

export const CONTEXT_CONFIG_VARIANTS = Object.freeze({
  baseline: BASELINE,
  full: FULL,
  temporal_history_only: Object.freeze({
    ...BASELINE,
    includeTemporalHistory: true,
  }),
  expected_but_missing_only: Object.freeze({
    ...BASELINE,
    includeExpectedButMissing: true,
  }),
  calculators_prefilled: Object.freeze({
    ...BASELINE,
    includeCalculatorResults: true,
  }),
  patient_context_only: Object.freeze({
    ...BASELINE,
    patientContextProfile: true,
    prevalenceCalibration: true,
  }),
  cant_miss_full_only: Object.freeze({
    ...BASELINE,
    cantMissGrounding: 'full',
  }),
});

/**
 * @param {string} configId
 * @returns {object}
 */
export function getContextConfigVariant(configId) {
  return CONTEXT_CONFIG_VARIANTS[configId] || CONTEXT_CONFIG_VARIANTS.baseline;
}
